export interface Agreement {
  agreementCode: string;
  agreementId: number;
}
